import NoteStore from '../stores/NoteStore.js';
import SessionStore from '../stores/SessionStore.js'
import useStores from './useStores.js';

import Header from './Header.js';

import './App.css';

function PageSuccess() {
  useStores([SessionStore]);

  return (
    <>
      <Header />
      <div className="middle large">
        ¡Esa es la nota correcta!
      </div>
      <div className="bottom">
        <div class="buttons">
          <button
            onClick={() => {
              SessionStore.nextCard();
            }}
          >
            Continuar
          </button>
        </div>
      </div>
    </>
  );
}

export default PageSuccess;
